import { Interval, type ScheduleData, ScheduleFrequency, ScheduleFrequencyMap } from "@qendo/schedule";
import { View } from "react-native";
import { DataListItem } from "~/components/layout/DataListItem";
import { Subtitle } from "~/components/layout/text";
import { Nothing } from "~/components/permission/Nothing";
import { Only } from "~/components/permission/Only";
import { Gap } from "~/constants/layout";
import { formatTimes, formatWeekdayString } from "~/util/qendo/schedule";

export type ScheduleProps = {
    schedule: ScheduleData | null | undefined;
};

export const Schedule = ({ schedule }: ScheduleProps) => {
    if (!schedule?.frequency) {
        return <Nothing />;
    }

    const days = formatWeekdayString(schedule.days);
    const interval = `Every ${schedule.interval} days`;
    const every = schedule.cycle?.every === Interval.day ? "days" : "weeks";
    const cycle = `Use for ${schedule.cycle?.use_for} ${every}, pause for ${schedule.cycle?.pause_for} ${every}`;
    const times = formatTimes(schedule.times);

    const body = (
        <View style={Gap.xxs}>
            <Only when={[ScheduleFrequency.as_needed, ScheduleFrequency.daily].includes(schedule.frequency)}>
                <Subtitle size="base" colour="primary">
                    {ScheduleFrequencyMap[schedule.frequency].label}
                </Subtitle>
            </Only>
            <Only when={schedule.frequency === ScheduleFrequency.specific_days}>
                <Subtitle size="base" colour="primary">
                    {days}
                </Subtitle>
            </Only>
            <Only when={schedule.frequency === ScheduleFrequency.interval}>
                <Subtitle size="base" colour="primary">
                    {interval}
                </Subtitle>
            </Only>
            <Only when={schedule.frequency === ScheduleFrequency.cyclical}>
                <Subtitle size="base" colour="primary">
                    {cycle}
                </Subtitle>
            </Only>
            <Only not when={schedule.frequency === ScheduleFrequency.as_needed}>
                {times && (
                    <Subtitle size="base" colour="primary">
                        {times}
                    </Subtitle>
                )}
            </Only>
        </View>
    );

    return <DataListItem title="Schedule" data={body} />;
};
